import React, { useContext } from 'react';
import {
    Divider,
    Content,
    Card,
    CardTitle,
    CardBody,
    Level, LevelItem,
    Tooltip,
    Button,
    Spinner,
    Grid,
    GridItem
} from '@patternfly/react-core';
import { AuthContext } from 'shared/context/AuthContext';
import ChartUtilDisk from "./Storage/Chart/ChartUtilDisk";
import StorageInfo from "./Storage/StorageInfo";
import SftpInfo from "./Storage/SftpInfo";
import MountStorageInfoPrivate from "./Storage/MountStorageInfoPrivate";
import MountStorageInfoPublic from "./Storage/MountStorageInfoPublic";
import SummaryDiskInfo from "./Storage/SummaryDiskInfo";
import ArrowRightIcon from '@patternfly/react-icons/dist/esm/icons/arrow-right-icon';

import { SiCeph } from "react-icons/si";
import { RedoIcon } from '@patternfly/react-icons';

const StoragePanel = ({
  storageData,
  storageLoading,
  refetchStorage
}) => {
    const context = useContext(AuthContext);
    const userProfile = context.state.userProfile;
    const storagePortalButton = <Button component="a" variant="link" size="sm" icon={<ArrowRightIcon />} iconPosition="start" target="_blank" href="https://ceph.zspw.pl">Konsola</Button>

    const disk = storageData?.disk;
    const summary = storageData?.summary;
    const iscsi_target = storageData?.iscsi_target
    const nfs_exports = storageData?.nfs_exports

    const diskUsagePercent = disk?.size_bytes
        ? Math.round((disk.disk_usage / disk.size_bytes) * 100)
        : 0;

    // if (error) return <div>Error...</div>;
    // if (error) return null;

    function parseCephVersion(versionStr) {
        // przykładowy string:
        // "ceph version 16.2.15 (618f440892089921c3e944a991122ddc44e60516) pacific (stable)"
        const regex = /ceph version (\d+\.\d+\.\d+).* (\w+) \(/;
        const match = versionStr.match(regex);
        if (match) {
            return {
                version: match[1], // "16.2.15"
                release: match[2], // "pacific"
            };
        }
        return { version: null, release: null };
    }
    // if (!context.state.isAuthUser) return null;
    // 🔥 KLUCZOWE
    // if (storageLoading || !storageData) return null;
    if (!context.state.isAuthUser || !storageData) return null;
    return (
        <>
            <Card isCompact isFullHeight>
                <CardTitle>
                    <Level>
                        <LevelItem>
                            <Tooltip content={summary?.version}>
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                    <SiCeph style={{ transform: 'translateY(-2px)' }} />
                                    <span style={{ marginLeft: '8px', transform: 'translateY(-2px)', fontSize: 'var(--pf-global--FontSize--sm)' }}>
                                        Ceph Storage
                                    </span>
                                </span>
                            </Tooltip>
                        </LevelItem>
                        {/* <LevelItem>
                        {summary ? <small>Ceph Storage Cluster</small> : ""}
                    </LevelItem> */}
                        <LevelItem>
                            {summary ? <small style={{ fontSize: '12px', textTransform: 'capitalize' }}>Release: {parseCephVersion(summary.version).release}</small> : ""}
                        </LevelItem>
                        <LevelItem>
                            {summary ? <small style={{ fontSize: '12px' }}>Version: {parseCephVersion(summary.version).version}</small> : ""}
                        </LevelItem>
                    </Level>
                    {/* <br /> */}
                    <Divider />
                </CardTitle>
                <CardBody>
                    <Level>
                        <LevelItem><Content component="h4">Twoja pamięć masowa {userProfile.is_superuser && storagePortalButton}</Content></LevelItem>
                        {storageLoading && (
                            <>
                                <span style={{ display: "flex", alignItems: "center", gap: "8px", height: "100%" }}>
                                    <Spinner size="sm" />
                                    <small>Ładowanie...</small>
                                </span>
                            </>
                        )}
                        <LevelItem>
                            <Button
                                variant="plain"
                                icon={<RedoIcon />}
                                onClick={refetchStorage}
                                isDisabled={storageLoading}
                            />
                        </LevelItem>
                    </Level>
                    {!storageLoading && disk && (
                        <Grid
                            hasGutter
                            span={12}
                            style={{
                                fontSize: "13px",
                                lineHeight: "1.6"
                            }}
                        >
                            <GridItem span={6}>
                                <ChartUtilDisk
                                    diskUsagePercent={diskUsagePercent}
                                    diskUsageBytes={disk.disk_usage}
                                    diskSize={disk.size_bytes}
                                    loading={storageLoading}
                                />
                            </GridItem>
                            <GridItem span={6}>
                                <SummaryDiskInfo
                                    diskUsageBytes={disk.disk_usage}
                                    diskSize={disk.size_bytes}
                                    diskName={disk.name}
                                    createdAt={disk.created_at}
                                    loading={storageLoading}
                                />
                            </GridItem>
                        </Grid>
                    )}
                    {!storageLoading && iscsi_target && (
                        <StorageInfo
                            userProfile={userProfile}
                            poolName={disk.pool}
                            iscsi_target={storageData?.iscsi_target}
                            loading={storageLoading}
                        />
                    )}
                    {!storageLoading && (
                        <SftpInfo
                            userProfile={userProfile}
                            loading={storageLoading}
                        />
                    )}
                    {!storageLoading && nfs_exports && (
                        <MountStorageInfoPrivate
                            context={context}
                            nfs_exports={nfs_exports}
                            userProfile={userProfile}
                            iscsi_target={storageData?.iscsi_target}
                        />
                    )}
                    {!storageLoading && (
                        <MountStorageInfoPublic
                            context={context}
                            nfs_exports={nfs_exports}
                            userProfile={userProfile}
                            iscsi_target={storageData?.iscsi_target}
                        />
                    )}
                </CardBody>
            </Card>
        </>
    );
};

export default StoragePanel;